var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#515151",
    d: "M15.742,19.966l-4.183-4.184c-0.384-0.383-0.384-1.011,0-1.394l0.349-0.35c0.383-0.383,1.011-0.383,1.394,0 l3.192,3.192l3.193-3.192c0.383-0.383,1.011-0.383,1.394,0l0.35,0.35c0.383,0.383,0.383,1.01,0,1.394l-4.184,4.184 c-0.206,0.206-0.482,0.298-0.752,0.282C16.224,20.264,15.949,20.172,15.742,19.966z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.6a8ece82289cf3a7c581bb87e53e448a.svg";
export { ForwardRef as ReactComponent };